__turbopack_context__.v({
  "container": "jegmjG_container",
});
